import { useMemo } from 'react';

import {
  Button,
  Icon,
  Menu,
  type MenuItemWithId,
  MenuTrigger,
} from '@iconik-io/uad';

import type { CommentSortExpression } from './use_comment_entity_list';

type CommentsSortMenuProps = {
  noComments: boolean;
  seekable: boolean;
  sort: CommentSortExpression;
  onSelectionChange: (value: CommentSortExpression) => void;
};

export function CommentsSortMenu({
  noComments,
  seekable,
  sort,
  onSelectionChange,
}: CommentsSortMenuProps) {
  const sortOptions = useMemo((): MenuItemWithId<CommentSortExpression>[] => {
    const options: MenuItemWithId<CommentSortExpression>[] = [];

    if (seekable) {
      options.push({
        label: 'By Timecode',
        id: 'time_start_milliseconds,asc',
        icon: 'player_time_format',
      });
    }

    options.push(
      { label: 'By Newest', id: 'date_created,desc', icon: 'sort_newest' },
      { label: 'By Oldest', id: 'date_created,asc', icon: 'sort_oldest' },
    );

    return options;
  }, [seekable]);

  return (
    <MenuTrigger>
      <Button
        size="s"
        variant="tertiary"
        isDisabled={noComments}
        endIcon={<Icon name="chevron_small_isolated_s" />}
        aria-label="Sort comments by date or timecode"
      >
        Sort
      </Button>
      <Menu
        headerTitle="Sort Comments"
        items={sortOptions}
        selectionMode="single"
        disallowEmptySelection
        selection={sort}
        onSelectionChange={onSelectionChange}
      />
    </MenuTrigger>
  );
}
